// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_7tT","option":"styles_option__2vUkL","selected":"styles_selected__3roeW"};